const defaultTheme = {
  mode: "dual",
  primary_color: "#fcb3c2",
  secondary_color: "#95fcd1",
  primary_dark: "#f59aae",
  primary_soft: "#fff5f7",
  secondary_soft: "#ecfff7"
};

function hexToRgb(hex) {
  const clean = String(hex || "").replace("#", "");

  if (clean.length !== 6) return null;

  const value = parseInt(clean, 16);

  return {
    r: (value >> 16) & 255,
    g: (value >> 8) & 255,
    b: value & 255
  };
}

function rgbString(hex, fallback) {
  const rgb = hexToRgb(hex);

  if (!rgb) return fallback;

  return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
}

export function applySiteTheme(theme = defaultTheme) {
  const finalTheme = {
    ...defaultTheme,
    ...(theme || {})
  };

  const secondaryColor = finalTheme.mode === "single" ? finalTheme.primary_color : finalTheme.secondary_color;
  const secondarySoft = finalTheme.mode === "single" ? finalTheme.primary_soft : finalTheme.secondary_soft;

  const primaryRgb = rgbString(finalTheme.primary_color, "252, 179, 194");
  const secondaryRgb = rgbString(secondaryColor, "149, 252, 209");

  const root = document.documentElement;

  root.style.setProperty("--color-primary", finalTheme.primary_color);
  root.style.setProperty("--color-secondary", secondaryColor);
  root.style.setProperty("--color-primary-dark", finalTheme.primary_dark);
  root.style.setProperty("--color-primary-soft", finalTheme.primary_soft);
  root.style.setProperty("--color-secondary-soft", secondarySoft);

  root.style.setProperty("--theme-primary-rgb", primaryRgb);
  root.style.setProperty("--theme-secondary-rgb", secondaryRgb);

  root.style.setProperty("--theme-primary-04", `rgba(${primaryRgb}, 0.04)`);
  root.style.setProperty("--theme-primary-08", `rgba(${primaryRgb}, 0.08)`);
  root.style.setProperty("--theme-primary-12", `rgba(${primaryRgb}, 0.12)`);
  root.style.setProperty("--theme-primary-16", `rgba(${primaryRgb}, 0.16)`);
  root.style.setProperty("--theme-primary-22", `rgba(${primaryRgb}, 0.22)`);
  root.style.setProperty("--theme-primary-28", `rgba(${primaryRgb}, 0.28)`);
  root.style.setProperty("--theme-primary-35", `rgba(${primaryRgb}, 0.35)`);
  root.style.setProperty("--theme-primary-48", `rgba(${primaryRgb}, 0.48)`);

  root.style.setProperty("--theme-secondary-04", `rgba(${secondaryRgb}, 0.04)`);
  root.style.setProperty("--theme-secondary-08", `rgba(${secondaryRgb}, 0.08)`);
  root.style.setProperty("--theme-secondary-12", `rgba(${secondaryRgb}, 0.12)`);
  root.style.setProperty("--theme-secondary-16", `rgba(${secondaryRgb}, 0.16)`);
  root.style.setProperty("--theme-secondary-22", `rgba(${secondaryRgb}, 0.22)`);
  root.style.setProperty("--theme-secondary-28", `rgba(${secondaryRgb}, 0.28)`);
  root.style.setProperty("--theme-secondary-35", `rgba(${secondaryRgb}, 0.35)`);
  root.style.setProperty("--theme-secondary-48", `rgba(${secondaryRgb}, 0.48)`);
}

export async function loadSiteTheme() {
  try {
    const response = await fetch("/api/site-theme", {
      headers: {
        Accept: "application/json"
      }
    });

    const data = await response.json();

    applySiteTheme(data.theme);
  } catch {
    applySiteTheme(defaultTheme);
  }
}
